<template>
  <!-- 绑定动态 class -->
  <el-row class="header-main"
    :class="{ 'header-active': isHeaderActive, 'header-scrolled': scrollFlag && isHeaderActive }"
    @mouseenter.native="handleMouseEnter" @mouseleave.native="handleMouseLeave">
    <!-- Logo -->
    <el-col class="logo" :xs="4" :sm="8">
      <router-link to="/" class="logo-container" v-if="screenWidth > 768">
        <!-- 深色 Logo (Active时显示) -->
        <img :src="logoUrl" alt="Logo" class="logo-img logo-dark" :class="{ 'is-visible': isHeaderActive }" />
        <!-- 白色 Logo (默认/透明时显示) -->
        <img src="https://blhc806.oss-cn-hangzhou.aliyuncs.com/wmUsImg/sysImg/logoFFF.png" alt="Logo"
          class="logo-img logo-light" :class="{ 'is-visible': !isHeaderActive }" />
      </router-link>
      <div class="logo-container" v-if="screenWidth <= 768" @click="MobileMenu()">
        <img :src="logoUrl" alt="Logo" class="logo-img logo-dark" :class="{ 'is-visible': isHeaderActive }" />
        <img src="https://blhc806.oss-cn-hangzhou.aliyuncs.com/wmUsImg/sysImg/logoFFF.png" alt="Logo"
          class="logo-img logo-light" :class="{ 'is-visible': !isHeaderActive }" />
      </div>

    </el-col>

    <!-- 导航菜单 -->
    <el-col class="nav_list" :xs="10" :sm="10" v-if="screenWidth > 768">
      <div v-for="(item, index) in navList" :key="index" class="nav-li"
        @click="index == 0 || index == 4 ? headerClick(item, index) : ''" @mouseenter="hoverIndex = index"
        @mouseleave="hoverIndex = -1">
        {{ item.name }}
        <div class="selLine" :class="{ 'isBlock': index === selIndex }"></div>
        <div class="children" v-show="shouldShowDropdown(index)">
          <div v-for="(value, inx) in categoryList[item.value]" :key="inx" @click.stop="" style="margin-bottom: 5px;">
            <span @click.stop="headerClick(item, index, value)" style="cursor: pointer !important;">{{
              value.categoryName }}</span>
          </div>
        </div>
      </div>
    </el-col>
    <el-col class="nav_list" :xs="16" :sm="10" v-if="screenWidth <= 768"></el-col>
    <!-- 登录按钮 -->

    <el-col class="btn_login" :xs="8" :sm="8">
      <!-- 情况 A: 未登录 (没有 email) -->
      <span class="sign" @click="handleLoginClick" v-if="!userEmail">SIGN IN</span>
      <!-- 情况 B: 已登录 -->
      <template v-else>
        <!-- 用户名，点击打开个人中心抽屉 -->
        <div class="user-info" @click="menberShow()"> {{ userName ? userName : userEmail }} </div>
        <!-- 购物车图标：仅限 Business Account (type == 1) 且已登录时展示 -->
        <div class="cart-icon" v-if="userType == 1" @click="handleClick(1, menberList[1].path)">
          <el-badge :value="cartNumber" class="item">
            <i class="el-icon-shopping-cart-2" style="font-size: 18px; font-weight: bold;"></i>
          </el-badge>
        </div>
      </template>
    </el-col>


    <!-- 登陆 -->
    <el-dialog :visible.sync="loginDialogVisible" :width="screenWidth < 768 ? '90%' : '420px'" :append-to-body="true"
      :close-on-click-modal="false" :show-close="false">
      <template slot="title">
        <div class="close-btn" @click="loginDialogVisible = false;"><i class="el-icon-close"></i></div>
      </template>
      <div class="login-box">
        <h3>SIGN IN</h3>
        <div class="login-text">
          Please enter your email address to sign in, or <span @click="handleRegister()">Create an Account</span>
        </div>
        <el-form :model="loginForm" size="medium" class="custom-form" :rules="rules.login" ref="loginForm">
          <el-form-item prop="email">
            <el-input v-model="loginForm.email" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" placeholder="Password" show-password></el-input>
          </el-form-item>
          <div class="forget-password" @click="handleForgetPassword">Forget Password?</div>
          <el-form-item>
            <el-button class="submit-btn" @click="login('loginForm')">SIGN IN</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 忘记密码 -->
    <el-dialog :visible.sync="forgetPassword" :width="screenWidth < 768 ? '90%' : '420px'" :append-to-body="true"
      :close-on-click-modal="false">
      <div class="login-box">
        <h3>FORGOT PASSWORD</h3>
        <div class="login-text">
          Please enter your email address, we'll send you a 6-digit code to reset your password so you can get back into
          your account.
        </div>
        <el-form :model="PasswordForm" size="medium" class="custom-form" ref="PasswordForm">
          <el-form-item>
            <el-input v-model="PasswordForm.email" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item class="input-wrapper">
            <el-input v-model="PasswordForm.verificationCode" placeholder="Digit code" class="custom-input">
              <!-- 使用 suffix 插槽放置按钮 -->
              <template slot="suffix">
                <el-button type="text" class="obtain-btn" :disabled="isCounting" @click="handleObtain(1)">
                  {{ btnText }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="submit-btn" @click="handleResetPassword">CONTINUE</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 新密码 -->
    <el-dialog :visible.sync="newPassword" :width="screenWidth < 768 ? '90%' : '420px'" :append-to-body="true"
      :close-on-click-modal="false">
      <div class="login-box">
        <h3>RESET YOUR PASSWORD</h3>
        <div class="login-text">
          Enter and confirm a new password below.
        </div>
        <el-form :model="newPasswordForm" size="medium" class="custom-form" ref="newPasswordForm"
          :rules="rules.newPassword">
          <el-form-item prop="password">
            <el-popover placement="right" width="280" trigger="focus" popper-class="password-popover"
              v-model="showResetPopover">
              <!-- 使用 resetStrength 计算属性 -->
              <div class="strength-content">
                <h4 class="strength-title">密码强度</h4>
                <div class="progress-bg">
                  <div class="progress-bar" :style="resetProgressStyle"></div>
                </div>
                <p class="requirements-title">必须包含</p>
                <ul class="rules-list">
                  <li :class="{ 'is-valid': resetStrength.rules.length }">
                    <i :class="resetStrength.rules.length ? 'el-icon-check' : 'el-icon-minus'"></i> 8-20 个字符
                  </li>
                  <li :class="{ 'is-valid': resetStrength.rules.upper }">
                    <i :class="resetStrength.rules.upper ? 'el-icon-check' : 'el-icon-minus'"></i> 1 个大写字母
                  </li>
                  <li :class="{ 'is-valid': resetStrength.rules.lower }">
                    <i :class="resetStrength.rules.lower ? 'el-icon-check' : 'el-icon-minus'"></i> 2 个小写字母
                  </li>
                  <li :class="{ 'is-valid': resetStrength.rules.number }">
                    <i :class="resetStrength.rules.number ? 'el-icon-check' : 'el-icon-minus'"></i> 1 个数字
                  </li>
                  <li :class="{ 'is-valid': resetStrength.rules.special }">
                    <i :class="resetStrength.rules.special ? 'el-icon-check' : 'el-icon-minus'"></i> 1 个特殊字符 (@#!?)
                  </li>
                </ul>
              </div>
              <!-- 输入框 -->
              <el-input slot="reference" v-model="newPasswordForm.password" placeholder="New Password"
                show-password></el-input>
            </el-popover>
          </el-form-item>
          <el-form-item prop="passwordConfirm">
            <el-input v-model="newPasswordForm.passwordConfirm" placeholder="Confirm Password" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="submit-btn" @click="submitResetPassword('newPasswordForm')">SUBMIT</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 注册 -->
    <el-dialog :visible.sync="registerShow" :width="screenWidth < 768 ? '90%' : '740px'" :append-to-body="true"
      :close-on-click-modal="false">
      <div class="login-box">
        <h3>CREATE AN ACCOUNT</h3>
        <div class="login-text" style="text-align: center;">
          Please fill in the following information to register an account.
        </div>
        <el-form :model="registerForm" size="medium" class="custom-form" :rules="rules.register" ref="registerForm">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item prop="firstName">
                <el-input v-model="registerForm.firstName" placeholder="First Name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item prop="lastName">
                <el-input v-model="registerForm.lastName" placeholder="Last Name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item prop="email">
                <el-input v-model="registerForm.email" placeholder="Email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item prop="password">
                <el-popover placement="right" width="280" trigger="focus" popper-class="password-popover"
                  v-model="showRegisterPopover">
                  <div class="strength-content">
                    <h4 class="strength-title">密码强度</h4>
                    <div class="progress-bg">
                      <div class="progress-bar" :style="registerProgressStyle"></div>
                    </div>
                    <p class="requirements-title">必须包含</p>
                    <ul class="rules-list">
                      <li :class="{ 'is-valid': registerStrength.rules.length }">
                        <i :class="registerStrength.rules.length ? 'el-icon-check' : 'el-icon-minus'"></i> 8-20 个字符
                      </li>
                      <li :class="{ 'is-valid': registerStrength.rules.upper }">
                        <i :class="registerStrength.rules.upper ? 'el-icon-check' : 'el-icon-minus'"></i> 1 个大写字母
                      </li>
                      <li :class="{ 'is-valid': registerStrength.rules.lower }">
                        <i :class="registerStrength.rules.lower ? 'el-icon-check' : 'el-icon-minus'"></i> 2 个小写字母
                      </li>
                      <li :class="{ 'is-valid': registerStrength.rules.number }">
                        <i :class="registerStrength.rules.number ? 'el-icon-check' : 'el-icon-minus'"></i> 1 个数字
                      </li>
                      <li :class="{ 'is-valid': registerStrength.rules.special }">
                        <i :class="registerStrength.rules.special ? 'el-icon-check' : 'el-icon-minus'"></i> 1 个特殊字符
                        (@#!?)
                      </li>
                    </ul>
                  </div>
                  <el-input slot="reference" v-model="registerForm.password" placeholder="Password"
                    show-password></el-input>
                </el-popover>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item style="text-align: center;">
            <el-button class="submit-btn" :style="{ 'width': screenWidth > 768 ? '380px' : '100%' }"
              @click="register('registerForm')">SUBMIT</el-button>
          </el-form-item>
          <div class="login-text" style="text-align: center;">
            Already have an account, <span @click="handleLoginClick">log in directly</span>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 验证码 -->
    <el-dialog :visible.sync="verifyCode" :width="screenWidth < 768 ? '90%' : '420px'" :append-to-body="true"
      :close-on-click-modal="false">
      <div class="login-box">
        <h3>VERIFY</h3>
        <div class="login-text">
          An email containing a verification code has been sent to [{{ registerForm.email }}], which is valid for 5
          minutes
        </div>
        <div class="custom-form input-wrapper">
          <el-input v-model="verifyCodeNumber" placeholder="Digit code" class="custom-input">
            <!-- 使用 suffix 插槽放置按钮 -->
            <template slot="suffix">
              <el-button type="text" class="obtain-btn" :disabled="isCounting" @click="handleObtain(0)">
                {{ btnText }}
              </el-button>
            </template>
          </el-input>
        </div>
        <el-button class="submit-btn" @click="handleContinue">CONTINUE</el-button>
      </div>
    </el-dialog>
    <!-- 退出登陆 -->
    <el-dialog :visible.sync="HideLogOut" :width="screenWidth < 768 ? '90%' : '400px'" :append-to-body="true"
      :close-on-click-modal="false">
      <div class="login-box">
        <h3>Log out</h3>
        <div class="login-text" style="text-align: center;">
          Are you sure you want to exit the current account?
        </div>
        <div class="login-btn">
          <el-button class="submit-btn"
            style="width: 40%;background-color: #fff;color: #2b231e;border: 1px solid #dcdfe6;"
            @click="HideLogOut = false">CANCEL</el-button>
          <el-button class="submit-btn" style="width: 40%;border: 1px solid #dcdfe6;"
            @click="handleLogout">CONFIRM</el-button>
        </div>

      </div>
    </el-dialog>
    <!-- 个人中心 -->
    <el-drawer :visible.sync="drawer" :direction="'rtl'" :before-close="handleClose" :append-to-body="true"
      :size="screenWidth < 768 ? '70%' : '500px'">
      <div class="menber">
        <div class="menber-name">WELCOME BACK 【{{ userName ? userName : userEmail }}】</div>
        <div class="account-type">{{ accountType[userType] }}</div>
        <ul class="menber-list">
          <li v-for="(item, index) in menberList" :key="index"
            v-show="!item.Permission || item.Permission.indexOf(userType) != -1">
            <span @click="handleClick(index, item.path)">{{ item.name }}</span> <span
              v-show="item.path === '/member/cart'" style="margin-left: 5px;"> ({{ cartNumber }}) </span>
          </li>
        </ul>
      </div>
    </el-drawer>
    <!-- 移动端菜单 -->
    <el-drawer :visible.sync="MobileShow" :direction="'ltr'" :before-close="handleMobileClose" :append-to-body="true"
      :size="screenWidth < 768 ? '80%' : '500px'">
      <div slot="title" class="MobileHead">
        <img :src="logoUrl" alt="Logo" class="Mobilelogo" />
        <div style="margin-left: 10px;">
          <strong class="sign" @click="handleLoginClick" v-if="!userEmail">Hello, SIGN IN</strong>
          <template v-else>
            <div class="user-info"> {{ userName ? userName : userEmail }} </div>
          </template>
        </div>
      </div>
      <div style="margin-top: 20px;">
        <div v-for="(item, index) in navList" :key="index" class="nav-li" @mouseenter="hoverIndex = index"
          @mouseleave="hoverIndex = -1">
          <strong @click="index == 0 || index == 4 ? headerClick(item, index) : ''"> {{ item.name }}</strong>
          <div class="mobile-children">
            <div v-for="(value, inx) in categoryList[item.value]" :key="inx" @click.stop="" style="margin-bottom: 5px;">
              <span @click.stop="headerClick(item, index, value)" class="mobile-span">
                <span>{{ value.categoryName }}</span>
                <i class="el-icon-arrow-right"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </el-row>
</template>

<script>
import "@/style/nav.css";
import Cookies from "js-cookie";
import { webUserLogin, webUserRegister, productCategoryPojoNoPage, webUserLogout, webUserSendEmail, webUserCheckCode, webUserUpdatePassword, webUserGetUserInfo, productShoppingCartNumber } from "@/api/user.js";
import { mapState, mapGetters } from "vuex";

export default {
  name: "TopNav",
  data() {
    const validatePassComplexity = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Required'));
      }
      const length = value.length >= 8 && value.length <= 20;
      const upper = /[A-Z]/.test(value);
      const lower = (value.match(/[a-z]/g) || []).length >= 2;
      const number = /[0-9]/.test(value);
      const special = /[^A-Za-z0-9]/.test(value);
      // 只有5项全部满足才算通过
      if (length && upper && lower && number && special) {
        callback();
      } else {
        callback(new Error('Password does not meet complexity requirements', special));
      }
    };

    // 2. 定义确认密码一致性校验器
    const validatePassConfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter password again'));
      } else if (value !== this.newPasswordForm.password) {
        callback(new Error('Two inputs don\'t match!'));
      } else {
        callback();
      }
    };
    return {
      logoUrl: "https://blhc806.oss-cn-hangzhou.aliyuncs.com/wmUsImg/sysImg/logo@2x.png",
      currentScroll: 0,
      scrollFlag: false,
      scrollTimer: null,
      hoverIndex: -1, // 用于控制下拉菜单显示的鼠标状态
      accountType: ['General Account', 'Business Account', 'Staff Account'],
      menberList: [
        { name: 'PRODUCT CENTER', path: '/member/productCenter', Permission: [1] },
        { name: 'SHOPPING CART', path: '/member/cart', Permission: [1] },
        { name: 'HISTORICAL ORDERS', path: '/member/order', Permission: [1] },
        { name: 'ADDRESS MANAGEMENT', path: '/member/address', Permission: [1] },
        { name: 'ARCHIVES CENTER', path: '/member/archives', Permission: [2] },
        { name: 'PERSONAL INFORMATION', path: '/member/account', Permission: [0, 1, 2] },
        { name: 'LOG OUT', path: '', Permission: [0, 1, 2] }
      ],
      // 导航配置
      navList: [
        { name: 'ABOUT US', path: '/' },
        { name: 'CURTAINS', path: '/goodsList', type: '0', value: "curtainList" },
        { name: 'BLINDS', path: '/goodsList', type: 1, value: "traceryList" },
        { name: 'HARDWARE', path: '/goodsList', type: 2, value: "accessoryList" },
        { name: 'CONTACT US', path: '/contact' }
      ],

      selIndex: 0,
      isHeaderActive: false,
      // screenWidth: document.documentElement.clientWidth || window.innerWidth,
      forgetPassword: false,
      // 登录
      loginDialogVisible: false,
      loginForm: {
        email: '',
        password: ''
      },
      // 忘记密码
      PasswordForm: {
        email: '',
        verificationCode: ''
      },
      // 新密码
      newPassword: false,
      newPasswordForm: {},
      // 注册
      registerShow: false,
      registerForm: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
      },
      // 验证码
      verifyCode: false,
      verifyCodeNumber: '',
      isCounting: false, // 是否正在倒计时
      count: 60,         // 倒计时秒数
      timer: null,       // 定时器引用
      // 校验规则
      rules: {
        login: {
          email: [
            { required: true, message: 'Please enter email', trigger: 'blur' },
            { type: 'email', message: 'Please enter a valid email address', trigger: ['blur', 'change'] }
          ],
          password: [{ required: true, message: 'Please enter password', trigger: 'blur' }]
        },
        register: {
          firstName: [{ required: true, message: 'Required', trigger: 'blur' }],
          lastName: [{ required: true, message: 'Required', trigger: 'blur' }],
          email: [
            { required: true, message: 'Required', trigger: 'blur' },
            { type: 'email', message: 'Please enter a valid email address', trigger: ['blur', 'change'] }
          ],
          password: [
            { required: true, message: 'Required', trigger: 'blur' },
            { validator: validatePassComplexity, trigger: 'blur' } // 添加自定义校验
          ]
        },
        newPassword: {
          password: [
            { required: true, message: 'Please enter password', trigger: 'blur' },
            { validator: validatePassComplexity, trigger: 'blur' }
          ],
          passwordConfirm: [
            { required: true, message: 'Please confirm password', trigger: 'blur' },
            { validator: validatePassConfirm, trigger: 'blur' }
          ]
        }
      },
      categoryList: [],
      // 个人中心抽屉
      drawer: false,
      HideLogOut: false,
      IsPopover: false,
      showRegisterPopover: false,
      showResetPopover: false,
      cartNumber: 0,
      isHovering: false, // 记录鼠标是否悬停在 header 上
      MobileShow: false, // 移动端菜单是否显示
    };
  },
  watch: {
    // 监听路由变化
    '$route': {
      handler() {
        this.updateRouterState();
      },
      immediate: true // 组件加载时立即触发一次
    },
    userInfo: {
      handler(val) {
        if (val && (val.firstName || val.lastName)) {
          console.log(this.userName);
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapGetters("app", ["getScreenWidth", "isMobile"]),
    ...mapState({
      user: state => state.user.user
    }),
    screenWidth() {
      return this.getScreenWidth;
    },
    userInfo() {
      if (!this.user) return {}; // state.user.user 为空时返回空对象
      try {
        return typeof this.user === 'string' ? JSON.parse(this.user) : this.user;
      } catch (e) {
        return {};
      }
    },
    userEmail() {
      return this.userInfo.email || ''; // 核心判断依据
    },
    userName() {
      const { firstName, lastName } = this.userInfo;
      if (firstName || lastName) {
        return `${firstName || ''} ${lastName || ''}`.trim();
      }
      return '';
    },
    userType() {
      return this.userInfo.type !== undefined ? this.userInfo.type - 0 : 0;
    },
    btnText() {
      return this.isCounting ? `${this.count}s` : 'Obtain';
    },
    registerStrength() {
      return this.calculatePasswordStrength(this.registerForm.password);
    },
    // 【重置密码】密码强度状态
    resetStrength() {
      return this.calculatePasswordStrength(this.newPasswordForm.password);
    },
    // 进度条样式也拆分
    registerProgressStyle() {
      return this.getStyleByScore(this.registerStrength.score);
    },
    resetProgressStyle() {
      return this.getStyleByScore(this.resetStrength.score);
    },
    // 进度条样式
    progressStyle() {
      const percentage = (this.score / 5) * 100;
      let color = '#e0e0e0'; // 默认灰
      if (this.score >= 1) color = '#f56c6c'; // 红 (弱)
      if (this.score >= 3) color = '#e6a23c'; // 黄 (中)
      if (this.score === 5) color = '#67c23a'; // 绿 (强 - 截图同款)
      return {
        width: `${percentage}%`,
        backgroundColor: color
      };
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // window.addEventListener('resize', this.handleResize);
    this.getCategoryList();
    this.getUserInfo();
    // 监听打开登录框事件
    this.$eventBus.$on('openLogin', this.handleLoginClick);
    // 1. 监听购物车更新事件
    this.$eventBus.$on('updateCartCount', this.getCartNum);
    this.getCartNum()
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    // window.removeEventListener('resize', this.handleResize);
    // 移除事件监听
    this.$eventBus.$off('openLogin', this.handleLoginClick);
    if (this.timer) {
      clearInterval(this.timer);
    }
    // 移除购物车更新事件监听
    this.$eventBus.$off('updateCartCount', this.getCartNum);
  },
  methods: {
    MobileMenu() {
      this.MobileShow = true;
    },
    handleMouseEnter() {
      this.isHovering = true;
      this.isHeaderActive = true;
    },

    // 鼠标离开
    handleMouseLeave() {
      this.isHovering = false;
      const currentPath = this.$route.path.toLowerCase();
      const transparentPaths = ['/', '/home', '/contact'];

      // 如果不是常驻深色的页面，且没有滚动，且鼠标离开了，才设为 false
      if (transparentPaths.includes(currentPath) && !this.scrollFlag) {
        this.isHeaderActive = false;
      }
    },
    menberShow() {
      if (this.userType == 1) {
        this.drawer = true;
      } else {
        this.drawer = true;
      }
    },

    getCartNum() {
      if (!this.userEmail) return;
      productShoppingCartNumber().then(res => {
        if (res.code == 1) {
          this.cartNumber = res.data.dataDetails;
        }
      });
    },
    submitResetPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 密码重置逻辑
          webUserUpdatePassword({ email: this.PasswordForm.email, password: this.newPasswordForm.password }).then(res => {
            if (res.code == 1) {
              // this.$message.success('Password reset successfully');
              this.newPassword = false;
              this.handleLoginClick();
            } else {
              this.$message.error(res.message);
            }
          })
        } else {
          this.$message.error('Please fill in the correct information');
        }
      });
    },
    calculatePasswordStrength(val) {
      if (!val) val = '';
      const rules = {
        length: val.length >= 8 && val.length <= 20,
        upper: /[A-Z]/.test(val),
        lower: (val.match(/[a-z]/g) || []).length >= 2,
        number: /[0-9]/.test(val),
        special: /[^A-Za-z0-9]/.test(val)
      };
      let score = 0;
      if (rules.length) score++;
      if (rules.upper) score++;
      if (rules.lower) score++;
      if (rules.number) score++;
      if (rules.special) score++;

      return { rules, score };
    },
    getStyleByScore(score) {
      const percentage = (score / 5) * 100;
      let color = '#e0e0e0';
      if (score >= 1) color = '#f56c6c';
      if (score >= 3) color = '#e6a23c';
      if (score === 5) color = '#67c23a';

      return {
        width: `${percentage}%`,
        backgroundColor: color
      };
    },
    // 忘记密码处理
    handleForgetPassword() {
      this.forgetPassword = true;
      this.loginDialogVisible = false;
      this.PasswordForm.email = this.loginForm.email;
      this.loginForm.password = '';
    },
    //校验忘记密码验证码
    handleResetPassword() {
      if (!this.PasswordForm.verificationCode) {
        this.$message.error('Please enter verification code');
        return;
      }
      webUserCheckCode(this.PasswordForm).then(res => {
        if (res.code == 1) {
          this.newPassword = true;
          this.newPasswordForm = {
            password: '',
            passwordConfirm: ''
          }

          this.forgetPassword = false
        } else {
          this.$message.error(res.message);
        }
      })
    },
    //获取验证码
    handleObtain(type = 0) {
      if (this.isCounting) return;
      if (type == 1 && !this.PasswordForm.email) {
        this.$message.error('Please enter email');
        return;
      }
      let email = type == 0 ? this.registerForm.email : this.PasswordForm.email;
      webUserSendEmail({ type: type, email: email }).then(res => {
        if (res.code == 1) {
          if (type == 0) { //注册
            this.verifyCode = true;
          }
          this.startCountdown();
        } else {
          this.$message.error(res.message);
        }
      })
    },

    startCountdown() {
      this.isCounting = true;
      this.count = 60; // 重置秒数
      // 3. 启动定时器
      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count--;
        } else {
          this.stopCountdown();
        }
      }, 1000);
    },

    stopCountdown() {
      this.isCounting = false;
      clearInterval(this.timer);
      this.timer = null;
    },
    //注册验证码
    handleContinue() {
      webUserCheckCode({ email: this.registerForm.email, verificationCode: this.verifyCodeNumber }).then(res => {
        if (res.code == 1) {
          let data = JSON.stringify(this.registerForm);
          webUserRegister(data).then((res) => {
            if (res.code == 1) {
              this.loginDialogVisible = true;
              this.registerShow = false;
              this.verifyCode = false;
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error(res.message);
        }
      })

    },
    // 退出登陆
    handleLogout() {
      webUserLogout({ email: this.userEmail }).then(res => {
        if (res.code == 1) {
          window.location.reload();
        }
      }).finally(() => {
        this.HideLogOut = false
        this.drawer = false;
        const keys = ['user', 'token', 'wuId'];
        keys.forEach(key => Cookies.remove(key))
        this.$store.commit('getUser', null);
        this.$store.commit('getUserId', '');
      })
      // 退出登陆后跳转到首页
      const currentPath = this.$route.path.toLowerCase();
      if (currentPath.includes("member")) {
        this.$router.push({ path: '/' })
      }
    },
    // 个人中心导航项
    handleClick(index, path = {}) {
      if (index == 6) {
        this.HideLogOut = true
        return;
      } else {
        this.$router.push({ path: path })
        this.drawer = false;
      }
    },
    // 关闭抽屉
    handleClose() {
      this.drawer = false;
    },
    handleMobileClose() {
      this.MobileShow = false;
    },
    // 点击菜单
    headerClick(data, index, value = {}) {
      this.selIndex = index;
      sessionStorage.setItem('NAV_ACTIVE_INDEX', index);
      this.MobileShow = false;
      window.scrollTo({ top: 0, behavior: "smooth" });
      let obj = {
        type: data.type || '',
        categoryId: value.categoryId || '',
        name: value.categoryName || ''
      }
      this.$router.push({
        path: data.path,
        query: data.path == '/goodsList' ? obj : {}
      })
    },

    // 根据当前路由更新状态
    updateRouterState() {
      const currentPath = this.$route.path;
      const transparentPaths = ['/', '/home', '/contact'];
      const isAlwaysSolidPage = !transparentPaths.includes(currentPath.toLowerCase());
      const currentQueryType = this.$route.query.type !== undefined ? String(this.$route.query.type) : null;
      if (isAlwaysSolidPage) {
        this.isHeaderActive = true;
      } else {
        // 关键修改：如果正在悬停 (isHovering) 或者是滚动状态 (scrollFlag)，则保持 Active
        this.isHeaderActive = this.scrollFlag || this.isHovering;
      }

      // 会员中心路由不展示选中
      if (currentPath.includes("member") || currentPath.includes("privacy") || currentPath.includes("TermsOfUse") || currentPath.includes("cookie")) {
        this.selIndex = -1
        return
      }

      if (currentPath == '/goodsList') {
        this.selIndex = currentQueryType - 0 + 1
        return
      }

      const foundIndex = this.navList.findIndex(item => {
        if (item.path !== currentPath) {
          return false;
        }
        if (item.type !== undefined) {
          return String(item.type) == currentQueryType;
        }
        return true;
      });
      this.selIndex = isAlwaysSolidPage ? (sessionStorage.getItem('NAV_ACTIVE_INDEX') - 0) : foundIndex;
    },

    // 控制下拉菜单
    shouldShowDropdown(index) {
      return index > 0 && index < 4 && this.hoverIndex === index;
    },

    //提高响应速度
    handleScroll() {
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.currentScroll = window.pageYOffset;
        // this.scrollFlag = this.currentScroll > 50;
        // console.log(this.$route.path.toLowerCase());

        // 滚动时也要触发状态更新，确保颜色切换正确

        if (this.$route.path.toLowerCase() == '/contact') {
          this.isHeaderActive = (this.currentScroll > 50) || this.isHovering;
        }
      }, 20);
    },

    //二级菜单
    getCategoryList() {
      productCategoryPojoNoPage().then((res) => {
        if (res.code == 1) {
          this.categoryList = res.data.dataList;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取个人信息
    getUserInfo() {
      if (!this.userEmail) return;
      webUserGetUserInfo({ email: this.userEmail }).then((res) => {
        if (res.code == 1) {
          Cookies.set('user', JSON.stringify(res.data.dataDetails));
          // this.$store.commit('getUser', res.data.dataDetails);
        }
      });
    },

    handleLoginClick() {
      // 检查组件是否可见
      const isVisible = this.$el.offsetParent !== null;
      if (!isVisible) return;

      this.loginDialogVisible = true;
      this.registerShow = false;
      this.MobileShow = false;
      this.loginForm = {
        email: '',
        password: ''
      }
    },
    // handleResize() {
    //   this.screenWidth = document.documentElement.clientWidth || window.innerWidth;
    // },

    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = JSON.stringify(this.loginForm);
          webUserLogin(data).then((res) => {
            if (res.code == 1) {
              Cookies.set('user', JSON.stringify(res.data.detail));
              Cookies.set('wuId', res.data.detail.wuId);
              Cookies.set('token', res.data.detail.token);
              this.$store.commit('getUser', res.data.detail);
              this.$store.commit('getUserId', Cookies.get("wuId"));
              window.location.reload();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    register(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.verifyCode = true
          this.registerShow = false;
          this.verifyCodeNumber = ''
        }
      });
    },
    handleRegister() {
      this.loginDialogVisible = false;
      this.registerShow = true;
      this.registerForm = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
      };
    },

  },

};
</script>

<style scoped>
::v-deep .el-drawer__header {
  margin-bottom: 0 !important;
}

::v-deep .el-button--text {
  color: #2B231E;
}

.header-main {
  z-index: 2200;
}

.children {
  transition: all 0.3s;
}

.custom-form {
  padding-top: 20px;
}

.password-popover {
  padding: 15px 20px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px;
  background: #fff;
  /* 确保有背景色 */
  z-index: 3000 !important;
  /* 确保在 el-dialog 之上，el-dialog 默认 z-index 2000+ */
}

.strength-content {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "NotoSerif", sans-serif;
}

.strength-title {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #666;
  font-weight: normal;
}

/* 进度条背景 */
.progress-bg {
  width: 100%;
  height: 6px;
  background-color: #f0f0f0;
  border-radius: 3px;
  margin-bottom: 15px;
  overflow: hidden;
}

/* 进度条填充 */
.progress-bar {
  height: 100%;
  transition: width 0.3s ease, background-color 0.3s ease;
  border-radius: 3px;
}

.requirements-title {
  font-size: 14px;
  color: #999;
  margin-bottom: 10px;
}

.rules-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.rules-list li {
  font-size: 13px;
  color: #606266;
  line-height: 24px;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

/* 图标样式 */
.rules-list li i {
  margin-right: 8px;
  font-size: 12px;
  width: 14px;
  /* 占位对齐 */
}

/* 校验通过时的样式 */
.rules-list li.is-valid {
  color: #67c23a;
  /* ElementUI 的成功绿 */
}

.rules-list li.is-valid i {
  font-weight: bold;
}
</style>
<style scoped lang="scss">
.password-validator-container {
  max-width: 400px;
  margin: 20px;
}

.selLine {
  display: none;
  height: 2px;
  background-color: #000;
  width: 100%;
  margin-top: 5px;

  /* 关键修改：去除空格，表示同时拥有这两个类 */
  &.isBlock {
    display: block;
  }
}

.custom-form {

  ::v-deep .el-input__inner,
  ::v-deep .el-textarea__inner {
    border-color: #2B231E;
    background-color: #fff;

    &:focus {
      border-color: #2B231E;
    }
  }
}

.submit-btn {
  background-color: #58473D;
  color: #fff;
  width: 100%;
  font-size: 18px;
  padding: 15px 0px;
  margin-top: 20px;
}

::v-deep .el-dialog__headerbtn:focus .el-dialog__close,
::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
  color: #2B231E;
}

.close-btn {
  text-align: right;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}

.close-btn:hover {
  color: #2B231E;
}
</style>
